import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import {
  LARGE_SCREEN_BREAKPOINT,
  MEDIUM_SCREEN_BREAKPOINT,
  SMALL_SCREEN_BREAKPOINT,
  TINY_SCREEN_BREAKPOINT,
  XLARGE_SCREEN_BREAKPOINT
} from '../constants/global.constants';
import { map } from 'rxjs';

@Injectable()
export class BreakpointsService {
  protected _breakpointObserver = inject(BreakpointObserver);

  isTinyScreen$ = this._breakpointObserver
    .observe(TINY_SCREEN_BREAKPOINT)
    .pipe(map(res => res.matches));

  isSmallScreen$ = this._breakpointObserver
    .observe(SMALL_SCREEN_BREAKPOINT)
    .pipe(map(res => res.matches));

  isMediumScreen$ = this._breakpointObserver
    .observe(MEDIUM_SCREEN_BREAKPOINT)
    .pipe(map(res => res.matches));

  isLargeScreen$ = this._breakpointObserver
    .observe(LARGE_SCREEN_BREAKPOINT)
    .pipe(map(res => res.matches));

  isXLargeScreen$ = this._breakpointObserver
    .observe(XLARGE_SCREEN_BREAKPOINT)
    .pipe(map(res => res.matches));
}
